<!--header-right-->
<template>
  <div class="c-hotel-filter-search-list">
    <div class="content">
      <template v-if="datalist && datalist.length > 0">
        <div class="item" v-for="(item, index) in datalist" :key="index" @click="$emit('select', item)">
          <div class="title">
            <div class="hotel-name">
              <img :src="_getIcon(item.Type)" alt="">
              <div v-light="[item.Name, KeyWord, 'thame']">{{item.Name}}</div>
            </div>
            <div class="subtitle">{{item.TypeName}}</div>
          </div>
          <div class="des" v-if="_getIsShowHotelEnName(item)" v-light="[item.NameEN, KeyWord, 'thame']">{{item.NameEN}}</div>
          <div class="des" v-if="item.SubTitle" v-light="[item.SubTitle, KeyWord, 'thame']">{{item.SubTitle}}</div>
        </div>
      </template>
      <!--<template v-else>
        &lt;!&ndash;<hs-null :title="$t('NoResult')" />&ndash;&gt;
        <div class="item border">
          <div class="no-data">{{$t('NoResult')}}</div>
        </div>
      </template>-->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {cloneObject} from '../../../common/utility/utils';
import {VueHighLight} from 'common/directives/lightText'
export default {
  props: {
    datalist: {
      type: Array,
      default: () => {
        return []
      }
    },
    KeyWord: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false,
      currentDatalist: cloneObject(this.datalist)
    }
  },
  directives: {
    light: VueHighLight()
  },
  methods: {
    /** 选中事件 */
    _select(item, key) {
      this.$emit('select', item, key)
    },
    // 获取对应类型的Icon
    _getIcon(Type) {
      let TypeObj = {
        1: 'Hotel.png', // 酒店 Hotel
        2: 'Markland.png', // 地标 Markland
        3: 'RailwayStation.png', // 机场车站 RailwayStation
        4: 'MetroStation.png', // 地铁站 MetroStation
        5: 'District.png', // 行政区 District
        6: 'Zone.png', // 商业区 Zone
        7: 'Brand.png', // 品牌 Brand
        8: 'Group.png', // 集团 Group
        9: 'Category.png', // 酒店类型 Category
        10: 'Feature.png', // 特色主题  Feature
        11: 'City.png', // 城市  City
        other: 'City.png', // 其他 City
        history: 'history.png' // 特色主题 other
      }
      let src = TypeObj[Type] ? TypeObj[Type] : TypeObj.other
      return require(`@/assets/image/components/c-hotel-filter/${src}`)
    },

    /** 获取是否显示酒店英文名称 */
    _getIsShowHotelEnName(item) {
      // 展示酒店英文名
      // 1. 搜索项是酒店
      // 2. 有酒店英文名
      // 3. 酒店英文名不同于酒店中文名
      // 4. 语言环境为中文
      if (
          item &&
          item.NameEN &&
          this.language === 'CN' && item.NameEN !== item.Name &&
          item.Type === 1
      ) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    HsNull: () => import('base/hs-null/hs-null')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
/** 超标支付样式  */
.c-hotel-filter-search-list
  padding-top 5px
  >>> .thame
    color $color_font_blue_4
  .content
    padding 0 10px
    .item
      @extend .flex-start
      flex-direction column
      border-bottom 1px solid $color_background_gray_3
      font-size 1rem
      padding 16px 0
      &:last-child
        border-bottom none
      &.border
        border-bottom 1px solid $color_background_gray_3
      img
        $wh(19px, 19px)
        flex-shrink 0
        display flex
        margin-right 15px
      .hotel-name
        @extend .flex-start
        align-items flex-start
        font-size 17px
        color $color_font_black
      .subtitle
        display flex
        flex-shrink 0
        font-size .8rem
        color $color_font_gray_1
        padding-left 25px
      .no-data
        width 100%
        font-size 16px
        color $color_font_gray_1
    .title
      @extend .flex-between
      align-items flex-start
      width 100%
    .des
      width 100%
      font-size .8rem
      color $color_font_gray_1
      padding-left 33px
      margin-top 5px
</style>
